
const colors = {
    main:'#09828b',
    mainLight:'#09828b30',
    contrast: '#db504a',
    red: '#',
    green: '#',
    redPink: '#',
    yellow: '#',
    lightBlue: '#',
    lighterBlue: '#'
}

const fonts = {
    title: 'Montserrat-Bold',
    subtitle: 'Montserrat-SemiBold',
    titleLight: 'Monserrat-Light',
    text: 'OpenSans-Regular'
}

export const stylesVars = {colors, fonts}
